import ParameterValue from "../api/models/test-series/ParameterValue";

export default function sortParameterValue(a: ParameterValue, b: ParameterValue): number {
  const labelA = a.parameter.name;
  const labelB = b.parameter.name;
  if (labelA.toLowerCase() < labelB.toLowerCase()) {
    return -1;
  }
  if (labelA.toLowerCase() > labelB.toLowerCase()) {
    return 1;
  }
  return 0;
}
